import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
import React from "react";

interface BasicSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  "data-testid"?: string;
}

export const BasicSearchBar: React.FC<BasicSearchBarProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
  "data-testid": dataTestId = "basic-search-bar",
}: BasicSearchBarProps): JSX.Element => {
  return (
    <div
      className={`flex flex-col justify-center items-center w-full ${className}`}
      data-testid={dataTestId}
    >
      <div className="w-full h-[38px] flex border border-[#DBDEE2] rounded-md">
        <label
          htmlFor="basic-search-field"
          className="sr-only"
          id="screen-reader-basic-search-label"
        >
          Search
        </label>
        <div className="relative w-full text-gray-400 focus-within:text-gray-700">
          <div
            className="absolute inset-y-0 left-0 flex items-center pointer-events-none pl-2"
            aria-hidden="true"
          >
            <MagnifyingGlassIcon
              className="h-5 w-5 stroke-2 text-gray-700"
              aria-hidden="true"
              id="basic-search-icon"
              data-testid="basic-search-icon"
            />
          </div>
          <input
            id="basic-search-field"
            name="basic_search_field"
            className="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-400 bg-white rounded-lg focus:outline-none focus:ring-0 focus:border-transparent sm:text-sm"
            placeholder={placeholder}
            type="search"
            data-testid="basic-search-input"
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};
